import React, { FC } from "react";
import { styled } from "@mui/material";
import imgGreenCheck from "assets/image/green-check.webp";

const GreenTick: FC<
  React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >
> = (props) => {
  return <Image {...props} src={imgGreenCheck} alt="Green Tick" />;
};

export default GreenTick;

const Image = styled("img")({
  marginLeft: "2px",
  marginRight: "2px",
  position: "relative",
  bottom: "-2px",
});
